import { useParams } from 'react-router-dom'

import ChatDrawer from '@app/pages/strategies/components/aiChat/components/chatDrawer'
import RoutableAiChatNavigationProvider from '@app/pages/strategies/components/aiChat/contexts/routeableAiChatNavigationProvider'
import RoutedList from '@app/pages/strategies/components/aiChat/routedList'
import RoutedNew from '@app/pages/strategies/components/aiChat/routedNew'
import RoutedShow from '@app/pages/strategies/components/aiChat/routedShow'
import { useStore } from '@app/store'
import { Chat, Pipeline, OrganizationChats } from '@graphql/documents/ai_assistant.graphql'
import type { PipelineEnum } from '@graphql/types'

const ChatRoot = ({ root }) => {
  const { strategyId } = useParams()

  return (
    <RoutableAiChatNavigationProvider basePath={`/strategy/${strategyId}/map/${root}`}>
      <ChatDrawer />
    </RoutableAiChatNavigationProvider>
  )
}

// NOTE: These routes assume the currently-viewed strategy is the chattable.
const routes = (root: string, pipelineId: PipelineEnum) => ({
  path: root,
  element: <ChatRoot root={root} />,
  loader: async () => {
    const { loaderQuery } = useStore.getState()

    return loaderQuery(Pipeline, { id: pipelineId })
  },
  children: [
    {
      index: true,
      element: <RoutedList />,
      loader: async ({ params }) => {
        const { strategyId: chattableId } = params
        const { loaderQuery } = useStore.getState()

        // NOTE: Load all chats, not just those with this pipelineId
        return loaderQuery(OrganizationChats, { chattableType: 'strategy', chattableId })
      }
    },
    {
      path: 'new',
      element: <RoutedNew pipelineId={pipelineId} />
    },
    {
      path: ':chatId',
      element: <RoutedShow />,
      loader: async ({ params }) => {
        const { chatId } = params
        const { loaderQuery } = useStore.getState()

        return loaderQuery(Chat, { id: chatId })
      }
    }
  ]
})

export default routes
